export const BOOKS_REQUEST = 'BOOKS_REQUEST'
export const BOOKS_REQUEST_BY_ID = 'BOOKS_REQUEST_BY_ID'
export const BOOK_GET_NEW_ID = 'BOOK_GET_NEW_ID'
export const BOOK_UPLOAD_FILE = 'BOOK_UPLOAD_FILE'
export const BOOK_UPLOAD_FILE_BASE_64 = 'BOOK_UPLOAD_FILE_BASE_64'
export const BOOKS_REPLACE = 'BOOKS_REPLACE'
export const BOOKS_SUCCESS = 'BOOKS_SUCCESS'
export const BOOK_SAVE = 'BOOK_SAVE'
export const BOOK_DELETE = 'BOOK_DELETE'
export const BOOK_UPDATE = 'BOOK_UPDATE'